import { render, staticRenderFns } from "./ParceiroConta.vue?vue&type=template&id=9b4a8d1c&"
import script from "./ParceiroConta.vue?vue&type=script&lang=js&"
export * from "./ParceiroConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports